import { Component, OnInit } from '@angular/core';
import { Router, RouteReuseStrategy } from '@angular/router';
import { NbIconLibraries } from '@nebular/theme';
import * as AOS from 'aos';
import { Subscription } from 'rxjs';
import { ToastService } from './@theme/service/toast.service';
import { CacheRouteReuseStrategy } from './cache-router-reuse-strategy';
import { EventBusService } from './common/event/event-bus.service';

@Component({
  selector: 'ngx-app',
  template: '<router-outlet></router-outlet>',
})
export class AppComponent implements OnInit {
  
  eventBusSub?: Subscription;

  constructor(private iconLibraries: NbIconLibraries,
    private eventBusService: EventBusService,
    private toast: ToastService,
    private router: Router,
    private routerResume: RouteReuseStrategy) {
    this.iconLibraries.registerFontPack('fas', { packClass: 'fas', iconClassPrefix: 'fa' });
    this.iconLibraries.registerFontPack('far', { packClass: 'far', iconClassPrefix: 'fa' });
    this.iconLibraries.registerFontPack('fab', { packClass: 'fab', iconClassPrefix: 'fa' });

    (<CacheRouteReuseStrategy> this.routerResume).clearHandlers();
  }

  ngOnInit() {

    this.eventBusSub = this.eventBusService.on('logout', (value) => {
      this.logout(value);
    });

    AOS.init();
  }

  logout(value: any) {
    this.router.navigate(['/auth/logout']).then(() => {
      if (value)
        this.toast.holdDuplicated('info', value);
    });
  }
}
